import { httpRequest } from "@services/http";
import type { Profile } from "./cmdListProfiles";

export class CommandUpdateProfileRoles {
  async run(profileId: number, roleIds: number[]): Promise<Profile> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/profiles/${profileId}/roles`;
    try {
      return await httpRequest<Profile>(url, {
        method: "PUT",
        body: { role_ids: roleIds },
      });
    } catch (error) {
      console.error("Error updating profile roles:", error);
      throw error;
    }
  }
}
